import Api from "../../../../https/Api";
import { paypalConfig } from "../../../../configs/Paypal";

export class PaymentService {
    private api: Api;
    constructor() {
        this.api = new Api();
    }

    //get
    async getTransactionById(id: string) {
        if (!id) {
            throw new Error("ID is required");
        }
        const endpoint = `transactions-details/get/${id}`;
       //console.log("Fetching transaction from:", endpoint);
        return this.api.simpleGet("transactions-details/get", id);
    }

    async getPaypalAccesToken() {
        let loginData = {
            username: paypalConfig.cliendID,
            password: paypalConfig.secret,
        };
        return this.api.postPaypalRequestToken(
            "https://api-m.sandbox.paypal.com/v1/oauth2/token",
            loginData
        );
    }

    async getOrderDetail(orderId: string) {
        return this.api.sendRequestById(
            "https://api-m.sandbox.paypal.com/v2/checkout/orders/",
            orderId
        );
    }

    async getCommissionFeeByCountryAndCityId(
        countryName: string,
        cityName: string
    ) {
        return this.api.simpleGetWithTwoParams(
            "settings/commissions-fees-country-city",
            countryName,
            cityName
        );
    }

    async getSpecialFeeByPropertyType(propertyType: string) {
        return this.api.simpleGet(
            "settings/specials-fees/property-type",
            propertyType
        );
    }
}
